import React from "react";

/**
 * Tiny label+error wrapper shared by InquiryForm and ContactDialog.
 * Lives in one file so the two forms can't drift apart.
 */
export default function Field({ id, label, error, children }) {
    return (
        <div>
            <label
                htmlFor={id}
                className="mb-2 block text-[11px] uppercase tracking-[0.3em] text-brand-goldSoft"
            >
                {label}
            </label>
            {children}
            {error && (
                <p
                    id={`${id}-error`}
                    role="alert"
                    className="mt-1 text-xs text-red-400"
                >
                    {error}
                </p>
            )}
        </div>
    );
}
